export const isObjectEmpty = (value?: object): boolean => Object.prototype.toString.call(value) === '[object Object]' && JSON.stringify(value) === '{}';
